// Gpr ads managements
// Bertrand Dessemond
jQuery(document).ready(function ($) {

    function isUrlValid(url) {
        return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
    }

    function statsConsultationPub(ids, nonce) {

        // console.log('consultationIds : ' + ids);
        if (nonce === '') {
            nonce = $(this).data('nonce');
        }

        $.ajax({
            url: gpr.ajaxurl,
            type: 'POST',
            data: {
                action: 'advertising_view',
                nonce: nonce,
                listIds: ids,
            },
        });

    }

    $.fn.addSlidePubDci = function (options) {
        var settings = $.extend({
            id:    0,
            link:  '',
            nonce: '',
            'durationPub': '6000',
        }, options);

        var slide = "";
        // console.log(settings.link);
        // On supprime les div vides au cas ou :

        //On vérifie que la slide n'est pas déjà présente dans le carrousel :
        if ($('#sidebar-ad-slider').find("[data-id-slide='" + settings.id + "']").length === 0) {

            if (settings.link !== '') {
                slide = '<li data-duration="'+settings.durationPub+'" data-id-slide="' + settings.id + '"><a class="adlink" data-nonce="' + settings.nonce + '" data-id="' + settings.id + '" data-target="' + settings.link + '"><img src="' + gpr.pub_url + 'media/pub?id=' + settings.id + '"></a></li>';
            } else {
                slide = '<li data-duration="'+settings.durationPub+'" data-id-slide="' + settings.id + '"><img src="' + gpr.pub_url + 'media/pub?id=' + settings.id + '"></li>';
            }

            $('#sidebar-ad-slider').data('flexslider').addSlide(slide);

            statsConsultationPub(settings.id, settings.nonce);
        }

        index = $('#sidebar-ad-slider li:empty').index();
        // console.log("index: " + index);
        if (index >= 0) {
            $('#sidebar-ad-slider').data('flexslider').removeSlide(index);
        }

    };

    $.fn.removeSlidePubDci = function (options) {
        var settings = $.extend({
            id: 0,
        }, options);

        var listItem = $('#sidebar-ad-slider').find("[data-id-slide='" + options.id + "']");
        var index = $("#sidebar-ad-slider li").index(listItem);
        $('#sidebar-ad-slider').data('flexslider').removeSlide(index);
    };

    /**
     * Extension pour générer le carrousel
     */
    $.fn.generateCarrousel = function (options) {
        // console.log('generate carrousel !');

        var settings = $.extend({
            // These are the defaults.
            position: "SITE",
            ss_speed: 7000,
            format: 'site',
            nonce: ''
        }, options);

        var isFetching = false;
        var slidesData;
        var init = true;

        $(this).flexslider({
            animation: "fade",
            slideshowSpeed: settings.ss_speed,
            // mousewheel: true,
            // allowOneSlide: true,
            controlNav: false,
            directionNav: false,
            before: function (slider) {
                if (init) {
                    init = false;
                    // slider.removeSlide(0);
                }
            },
            start: function (slider) {
                if (!isFetching) {
                    isFetching = true;
                    var listId = '';
                    $.ajax({
                            url: gpr.ajaxurl,
                            type: 'POST',
                            data: {
                                nonce: settings.nonce,
                                action: 'get_advertising_list',
                                position: settings.position,
                                format: settings.format
                            },
                            success: function (data) {
                                slider.removeSlide(0);

                                $.each(data, function (index, val) {
                                    listId = listId + val.id + ',';
                                    if (val.lien !== '') {
                                        slide = '<li data-duration="' + val.duration + '"><a class="adlink" data-nonce="' + val.nonce + '" data-id="' + val.id + '" data-target="' + val.lien + '"><img src="' + val.url + '"></a></li>';
                                    } else {
                                        slide = '<li  data-duration="' + val.duration + '"><img src="' + val.url + '"></li>';
                                    }
                                    slider.addSlide(slide);
                                });

                                //console.log(listId);


                            }

                        })
                        .done(function () {
                            statsConsultationPub(listId);
                        });
                } // !isFetching

            },
            after: function (slider) {
                // console.log('stop');
                // console.log($(slider.slides[slider.currentSlide]).data('duration'));
                // console.log($(slider.slides[slider.currentSlide]));
                // clears the interval
                slider.stop();
                // grab the duration to show this slide

                slider.vars.slideshowSpeed = $(slider.slides[slider.currentSlide]).data('duration');
                // start the interval
                slider.play();
            }
        });
    };

    /**
     * Extension pour générer le carrousel
     */
    $.fn.generateCarrouselPartenaires = function (options) {


        var settings = $.extend({
            // These are the defaults.
            position: "part",
            ss_speed: 7000,
            format: 'site',
            nonce: ''
        }, options);

        var isFetching = false;
        var slidesData;
        var init = true;
        if ($("body.ie8").length) {

            $.ajax({
                url: gpr.ajaxurl,
                type: 'POST',
                data: {
                    nonce: settings.nonce,
                    action: 'get_partenaires',
                    position: settings.position,
                    format: settings.format
                },
                success: function (data) {
                    var slide;
                    $.each(data, function (index, val) {
                        if (val.position !== 'PARRAIN') {
                            var titleSponsor = '';
                            if (val.position === 'INSTITU' || val.position === 'PARTENA') {
                                if (val.libellePublicite) {
                                    titleSponsor = '<div class="title-sponsor" >' + val.libellePublicite + '</div>';
                                } else {
                                    titleSponsor = '<div class="title-sponsor">&nbsp;</div>';
                                }
                            }

                            if (!val.lien) {
                                slide = '<li>' + titleSponsor + '<img src="' + val.url + '"></li>';
                            } else {
                                slide = '<li>' + titleSponsor + '<a href="' + val.lien + '" target="_blank" ><img class="img-logo-partenaires" src="' + val.url + '"></a></li>';
                            }
                            $('.list-sponsor').append(slide);

                            return;
                        }

                        if (!val.lien) {
                            lien = '';
                        } else {
                            lien = 'href="' + val.lien + '" target="_blank"';
                        }
                        slide = '<a class="sponsor-link" ' + lien + ' ><img class="img-logo-partenaires" src="' + val.url + '"></a>';

                        $('.list-sponsor-ie').append(slide);

                    });

                }
            });


            return;


        }

        $(this).flexslider({
            animation: "slide",
            animationLoop: true,
            slideshowSpeed: 3000,
            controlNav: false,
            itemWidth: 110,
            itemMargin: 30,
            minItems: 2,
            maxItems: 5,
            before: function (slider) {
                if (init) {
                    init = false;
                    slider.removeSlide(0);
                }
            },
            start: function (slider) {
                if (!isFetching) {
                    isFetching = true;
                    var listId = '';
                    $.ajax({
                        url: gpr.ajaxurl,
                        type: 'POST',
                        data: {
                            nonce: settings.nonce,
                            action: 'get_partenaires',
                            position: settings.position,
                            format: settings.format
                        },
                        success: function (data) {
                            // console.log(data);
                            var slide;
                            if ($.isArray(data)) {

                                $.each(data, function (index, val) {
                                    if (val.position !== 'PARRAIN') {
                                        var titleSponsor = '';
                                        if (val.position === 'INSTITU' || val.position === 'PARTENA') {
                                            if (val.libellePublicite) {
                                                titleSponsor = '<div class="title-sponsor" >' + val.libellePublicite + '</div>';
                                            } else {
                                                titleSponsor = '<div class="title-sponsor">&nbsp;</div>';
                                            }
                                        }

                                        if (!val.lien) {
                                            slide = '<li>' + titleSponsor + '<img src="' + val.url + '"></li>';
                                        } else {
                                            slide = '<li>' + titleSponsor + '<a href="' + val.lien + '" target="_blank" ><img class="img-logo-partenaires" src="' + val.url + '"></a></li>';
                                        }
                                        $('.list-sponsor').append(slide);

                                        return;
                                    }

                                    listId = listId + val.id + ',';

                                    if (!val.lien) {
                                        lien = '';
                                    } else {
                                        lien = 'href="' + val.lien + '" target="_blank"';
                                    }
                                    slide = '<li><a class="sponsor-link" ' + lien + ' ><img class="img-logo-partenaires" src="' + val.url + '"></a></li>';

                                    slider.addSlide(slide);

                                });

                            } // fin si array

                        }
                    });
                } // !isFetching

            }
        });
    };

    /**
     * On enregistre les clics
     */
    $(document).on('click', '.adlink', function (event) {
        event.preventDefault();

        var id = $(this).data('id');
        var nonce = $(this).data('nonce');
        var link = $(this).data('target');

        $.ajax({
            url: gpr.ajaxurl,
            type: 'POST',
            data: {
                action: 'advertising_click',
                nonce: nonce,
                id: id,
            },
        });

        //traitement stats
        if (isUrlValid(link)) {
            window.open(link, '_blank');
        }


        /* Act on the event */
    });
});
